import { Component, OnInit, ViewChild, Renderer } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { AlertService } from 'src/app/services/alert.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AccessControlService } from 'src/app/services/access-control.service';
import { CheckPermissionService } from 'src/app/services/check-permission.service';
import Swal from 'sweetalert2';
// declare var $: any

@Component({
  selector: 'app-add-app-user',
  templateUrl: './add-app-user.component.html',
  styleUrls: ['./add-app-user.component.css']
})
export class AddAppUserComponent implements OnInit {
  userList: any = [];
  is_add: boolean = false;
  static is_edit: boolean = false;
  static is_delete: boolean = false;
  static app_id: any;
  application: any = [];
  application_name: any;
  app_code: any;
  constructor(private renderer: Renderer,
    private router: Router,
    private authService: AuthService,
    private accessControlService: AccessControlService,
    private checkPermissionService: CheckPermissionService,
    private activatedRoute: ActivatedRoute) {
    AddAppUserComponent.app_id = this.activatedRoute.snapshot.params['id'];
    this.app_code = this.activatedRoute.snapshot.queryParamMap.get('opt')
  }

  ngOnInit() {
    // this.is_add = this.checkPermissionService.getAction('add');
    // UserListingComponent.is_edit = this.checkPermissionService.getAction('edit');
    // UserListingComponent.is_delete = this.checkPermissionService.getAction('delete');
    this.accessControlService.getRoute.next(true)
    localStorage.setItem('option', 'global_access_control');
    // this.listallUsers_within_App();
    this.listallUsers()
    // this.getapplicationbyId();
  }


  getapplicationbyId() {
    this.accessControlService.getapplicationbyId(AddAppUserComponent.app_id).subscribe((res) => {
      this.application = res;
      this.application_name = this.application.application_name;
    }, error => {
      console.log(error)
    },
      () => {

      })
  }
  listallUsers() {
    this.authService.listallUsers().subscribe((res) => {
      this.userList = res;
    }, error => {

    }, () => {
    })
  }

  verify(action: any) {
    Swal({
      title: 'Are you sure you want delete?',
      text: "You won't be able to revert this!",
      type: 'warning',
      width: '30%',
      showCancelButton: true,
      confirmButtonColor: 'text-danger',
     cancelButtonColor: '#f8ac59',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.value) {
        Swal(
          'Deleted!',
          'User has been deleted.',
          'success'
        ).then(() => {
          // this should execute now
          this.authService.deleteUser(action, localStorage.getItem('org_id'), { orginalClient: true }).subscribe((res) => {
          }, error => { },
            () => {
              this.listallUsers();
            })
        });
      }

    })
  }

  ngAfterViewInit(): void {
    this.renderer.listenGlobal('document', 'click', (event) => {
      if (event.target.hasAttribute('method-action')) {
        var action = event.target.getAttribute("method-action");
        this.verify(action)
      }
      if (event.target.hasAttribute('data-action')) {
        var action = event.target.getAttribute("data-action");
        this.router.navigate([action]);
      }
    });
  }
}
